// inputNode.js
import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { useStore } from '../store';

export const InputNode = ({ id, data }) => {
  const [currName, setCurrName] = useState(data?.inputName || id.replace('customInput-', 'input_'));
  const [inputType, setInputType] = useState(data?.inputType || 'Text');
  const updateNodeField = useStore((state) => state.updateNodeField);

  return (
    <BaseNode
      id={id}
      data={data}
      title="Input"
      handles={[
        { type: 'source', position: Position.Right, id: `${id}-value` }
      ]}
    >
      <Input
        label="Name"
        value={currName}
        onChange={(e) => {
          setCurrName(e.target.value);
          updateNodeField(id, 'inputName', e.target.value);
        }}
      />
      <Select
        label="Type"
        value={inputType}
        onChange={(e) => {
          setInputType(e.target.value);
          updateNodeField(id, 'inputType', e.target.value);
        }}
        options={[
          { value: 'Text', label: 'Text' },
          { value: 'File', label: 'File' }
        ]}
      />
    </BaseNode>
  );
}
